export const commonZhCN = {
  common: {
    you: '你',
    confirm: '确定',
    cancel: '取消',
    loading: '加载中...',
  },
  home: {
    slogan: 'Generative Learning in Multi-Agent Interactive Classroom',
    greeting: '嗨，',
  },
  toolbar: {
    languageHint: '课程将以此语言生成',
    pdfParser: '解析器',
    pdfUpload: '上传 PDF',
    removePdf: '移除文件',
    webSearchOn: '已开启',
    webSearchOff: '点击开启',
    webSearchDesc: '生成前搜索网络获取最新资料，让内容更丰富准确',
    webSearchProvider: '搜索引擎',
    webSearchNoProvider: '请在设置中配置搜索引擎 API Key',
    selectProvider: '选择模型服务商',
    configureProvider: '配置模型',
    configureProviderHint: '请先配置至少一个模型服务商才能生成课程',
    enterClassroom: '进入课堂',
    advancedSettings: '高级设置',
    ttsTitle: '语音合成',
    ttsHint: '选择 AI 教师的朗读音色',
    ttsPreview: '试听',
    ttsPreviewing: '播放中...',
  },
  export: {
    pptx: '导出 PPTX',
    resourcePack: '导出教学资源包',
    resourcePackDesc: 'PPTX + 交互式页面',
    exporting: '正在导出...',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
  },
} as const;

export const commonEnUS = {
  common: {
    you: 'You',
    confirm: 'Confirm',
    cancel: 'Cancel',
    loading: 'Loading...',
  },
  home: {
    slogan: 'Generative Learning in Multi-Agent Interactive Classroom',
    greeting: 'Hi, ',
  },
  toolbar: {
    languageHint: 'Course will be generated in this language',
    pdfParser: 'Parser',
    pdfUpload: 'Upload PDF',
    removePdf: 'Remove file',
    webSearchOn: 'Enabled',
    webSearchOff: 'Click to enable',
    webSearchDesc: 'Search the web for up-to-date information before generation',
    webSearchProvider: 'Search engine',
    webSearchNoProvider: 'Configure search API key in Settings',
    selectProvider: 'Select provider',
    configureProvider: 'Set up model',
    configureProviderHint: 'Configure at least one model provider to generate courses',
    enterClassroom: 'Enter Classroom',
    advancedSettings: 'Advanced Settings',
    ttsTitle: 'Text-to-Speech',
    ttsHint: 'Choose a voice for the AI teacher',
    ttsPreview: 'Preview',
    ttsPreviewing: 'Playing...',
  },
  export: {
    pptx: 'Export PPTX',
    resourcePack: 'Export Resource Pack',
    resourcePackDesc: 'PPTX + interactive pages',
    exporting: 'Exporting...',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
  },
} as const;
